














import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class PageSection extends Vue {
  @Prop({ required: true }) readonly label!: string;
  @Prop({ default: false }) readonly required!: boolean;
}
